import { SimpleGrid } from '@mantine/core';
import { useContainerQuery } from 'src/UI/app-container/ContainerBreakpoint';
import { ProfileFormField } from 'src/non-financial-data/components/ProfileFormField';

export function PersonalDetailsFields() {
  const cq = useContainerQuery();

  return (
    <>
      <SimpleGrid cols={cq({ base: 1, sm: 2, md: 4 })}>
        <ProfileFormField entityType="PersonalDetails" fieldName="title" />
        <ProfileFormField entityType="PersonalDetails" fieldName="first_name" />
        <ProfileFormField entityType="PersonalDetails" fieldName="preferred_name" />
        <ProfileFormField entityType="PersonalDetails" fieldName="last_name" />
      </SimpleGrid>

      <SimpleGrid cols={cq({ base: 1, sm: 2 })}>
        <ProfileFormField entityType="PersonalDetails" fieldName="phone_number" />
        <ProfileFormField entityType="PersonalDetails" fieldName="email_address" />
      </SimpleGrid>

      <ProfileFormField entityType="PersonalDetails" fieldName="address" />

      <SimpleGrid cols={cq({ base: 1, sm: 2, md: 3 })}>
        <ProfileFormField entityType="PersonalDetails" fieldName="date_of_birth" />
        <ProfileFormField entityType="PersonalDetails" fieldName="gender" />
        <ProfileFormField entityType="PersonalDetails" fieldName="marital_status" />
      </SimpleGrid>

      <SimpleGrid cols={cq({ base: 1, sm: 2, md: 3 })}>
        <ProfileFormField
          entityType="PersonalDetails"
          fieldName="national_insurance_number"
          label="National Insurance Number"
        />
        <ProfileFormField entityType="PersonalDetails" fieldName="place_of_birth" />
        <ProfileFormField entityType="PersonalDetails" fieldName="nationality" />
      </SimpleGrid>

      <SimpleGrid cols={cq({ base: 1, sm: 2 })}>
        <ProfileFormField entityType="PersonalDetails" fieldName="uk_residency_status" />
        <ProfileFormField
          entityType="PersonalDetails"
          fieldName="domiciled_in_the_uk"
          label="Domiciled in the UK"
        />
      </SimpleGrid>

      <ProfileFormField entityType="SoftFacts" fieldName="interests" />
      <ProfileFormField entityType="SoftFacts" fieldName="hobbies" />
      <ProfileFormField entityType="SoftFacts" fieldName="family" />
    </>
  );
}
